"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (obj, list = [], defaults = {}) => Object.keys(obj)
    .filter(key => list.some(prefix => key.startsWith(prefix)))
    .reduce((env, key) => {
    // eslint-disable-next-line no-param-reassign
    env[key] = obj[key];
    return env;
}, defaults);
//# sourceMappingURL=collect-keys.js.map